import React from 'react';

export const RightArrowRounded = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.41974 4.61041C8.12688 4.31754 8.12693 3.84276 8.41974 3.54986C8.71264 3.25697 9.1874 3.25697 9.48029 3.54986L16.0008 10.0694C17.0636 11.1323 17.0636 12.8679 16.0008 13.9307L9.48029 20.4503C9.1874 20.7431 8.71264 20.7431 8.41974 20.4503C8.12685 20.1574 8.12685 19.6826 8.41974 19.3897L14.9393 12.8692C15.4164 12.3921 15.4164 11.607 14.9393 11.1299L8.41974 4.61041Z"
      fill="#64748B"
    />
  </svg>
);
